export default {
  VIDEO_PREVIEW: 1,
  COVER_IMAGE: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/show-media-type-values.js